export const HISTORY_PAGINATION_DEFAULT = {
  current: 1,
  pageSize: 10
};

export const PIPELINE_TYPES = { STREAMING: 'STREAMING' };

export const en = {
  columns: {
    pipelineName: 'Pipeline Name',
    description: 'Description',
    schedule: 'Schedule ( UTC )',
    nextSchedule: 'Next Schedule ( {{tz}} )',
    runStatus: 'Run Status ( {{tz}} )',
    status: 'Status',
    actions: 'Actions'
  },
  streamingBadgeText: 'Streaming',
  actions: {
    runPipeline: {
      tooltip: 'Launch Pipeline',
      confirmTitle: 'Launch Pipeline',
      confirmContent:
        'You have selected “<b>{{name}}</b>“ to be executed. Are you sure about this selection?',
      confirmOkText: 'Launch Pipeline',
      successMessage: 'Pipeline successfully executed.'
    },
    schedule: {
      tooltip: 'Schedule',
      modalTitle: 'Schedule Pipeline',
      scheduleOkText: 'Schedule',
      unscheduleOkText: 'Unschedule',
      currentSchedule: 'Current Schedule',
      cronExpressionMode: 'Cron expression',
      frequencyBasedMode: 'Frequency based',

      headerNote:
        'Note: The pipeline schedule will be in UTC timezone which is {{hrs}} hrs from your {{tz}} timezone.'
    },
    history: {
      tooltip: 'History',
      modalTitle: 'View History of executions',
      refreshList: 'Refresh List',
      hide: 'Hide',
      view: 'View',
      errorDescription: 'Error Description'
    },
    stopPipeline: {
      tooltip: 'Stop Pipeline',
      modalTitle: 'Stop Pipeline',
      errorDescription: 'Error Description'
    }
  }
};
